export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Premium%20white%20and%20cream%20sneakers%20collection%20arranged%20on%20light%20marble%20surface%20with%20soft%20natural%20window%20light%2C%20minimalist%20editorial%20product%20photography%2C%20airy%20composition%20with%20negative%20space%2C%20subtle%20green%20plant%20leaves%20in%20background%2C%20high-end%20fashion%20catalog%20aesthetic%2C%20warm%20neutral%20tones&width=1600&height=900&seq=hero-sneakers-2026&orientation=landscape"
          alt="Premium sneakers collection - Basetao Spreadsheet shopping guide"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 text-white/90 text-xs md:text-sm font-medium mb-6">
            <i className="ri-sparkling-line"></i>
            <span>Updated for 2026 — Independent Research &amp; Guides</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
            Basetao Spreadsheet — The Complete Guide To Finds, Reviews &amp; Shopping Resources
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            Discover updated Basetao spreadsheets, verified product guides, shipping cost analysis, warehouse tips, discount information and expert buying tutorials — all in one independent resource hub.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-accent-500 text-white font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/25"
            >
              Basetao Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white/15 backdrop-blur-sm border border-white/30 text-white font-semibold text-sm md:text-base hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8 text-white/60 text-xs md:text-sm">
            <div className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>Updated Weekly</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>Independent Research</span>
            </div>
            <div className="flex items-center gap-1.5">
              <i className="ri-checkbox-circle-line text-accent-400"></i>
              <span>Beginner Friendly</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}